export const CURRENT_APP_VERSION = '20250904.1';
